import * as React from 'react'

import PhotosListIntro from '@/components/PhotosListIntro'
import PhotosListKeyboardControls from '@/components/PhotosListKeyboardControls'
import PhotosListPhoto from '@/components/PhotosListPhoto'
import type { PhotoPayload } from '@/constant/types'
import { cn, getSanityImageAspectRatio } from '@/lib/utils'

type PhotosListProps = {
  photos: PhotoPayload[]
  header?: string
  date?: string
  subheader?: string
}

export default function PhotosList({
  photos,
  header,
  date,
  subheader,
}: PhotosListProps) {
  const showIntro = !!header
  const photoClassname = 'photos-list-photo'
  return (
    <>
      {showIntro && (
        <PhotosListIntro
          header={header}
          date={date}
          subheader={subheader}
          className={photoClassname}
        />
      )}
      {photos.map(({ _key, ...image }) => {
        const paddingTop = getSanityImageAspectRatio(image, 'paddingTop')
        return (
          <div
            key={_key}
            className={cn(
              'relative mb-48 flex h-auto items-center justify-start last:mb-0',
              'sI:static sI:h-[100svh] sI:py-12! sI:mb-0',
              photoClassname,
            )}
            style={{ paddingTop }}
          >
            <PhotosListPhoto
              className='sI:relative absolute top-0 left-0 h-full w-full'
              image={image}
            />
            {/* <figcaption className='text-sm'>
              {city && <p>City: {city}</p>}
              {country && <p>Country: {country}</p>}
              {date && <p>Captured: {formatDate({ date })}</p>}
            </figcaption> */}
          </div>
        )
      })}
      <PhotosListKeyboardControls photosClassName={photoClassname} />
    </>
  )
}
